// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transparent__bEivzor7io{opacity:0%}`, "",{"version":3,"sources":["webpack://./src/components/phoneNumberCountryFlag/phoneNumberCountryFlag.module.scss"],"names":[],"mappings":"AAAA,yBACE,UAAA","sourcesContent":[".transparent {\n  opacity: 0%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transparent": `transparent__bEivzor7io`
};
export default ___CSS_LOADER_EXPORT___;
